import { MetricFilterOperatorKey, MetricFilterOperatorLabel } from './types';

export const defaultOperators = [
  { key: MetricFilterOperatorKey.Is, label: MetricFilterOperatorLabel.Is },
  {
    key: MetricFilterOperatorKey.IsNot,
    label: MetricFilterOperatorLabel.IsNot,
  },
  {
    key: MetricFilterOperatorKey.Contains,
    label: MetricFilterOperatorLabel.Contains,
  },
  {
    key: MetricFilterOperatorKey.NotContains,
    label: MetricFilterOperatorLabel.NotContains,
  },
];

export const metricFilterOperators = [
  { key: MetricFilterOperatorKey.Is, label: MetricFilterOperatorLabel.Is },
  {
    key: MetricFilterOperatorKey.IsNot,
    label: MetricFilterOperatorLabel.IsNot,
  },
  {
    label: MetricFilterOperatorLabel.GreaterThan,
    key: MetricFilterOperatorKey.GreaterThan,
  },
  {
    label: MetricFilterOperatorLabel.LowerThan,
    key: MetricFilterOperatorKey.LowerThan,
  },
];

export const METRICS_MAX = 10;
export const SPLITS_MAX = 5;

export const notApplicableValue = 'N/A';

// temporary code block until continue this problem investigation
export const facebookRegionSplitKey = 'target_region';
export const facebookDeviceSplits = new Set([
  'publisher_platform',
  'impression_device',
  'device_platform',
]);
export const facebookRegionSplits = new Set([
  facebookRegionSplitKey,
  'target_country',
]);
export const incompatibleRegionSplittingMetricKeys = new Set([
  'revenue_per_impression',
  'avg_purchase_value',
  'action_values:offsite_conversion.fb_pixel_purchase',
  'cost_per_action_type:lead',
  'cost_per_action_type:purchase',
  'actions:offsite_conversion.fb_pixel_lead',
  'actions:offsite_conversion.fb_pixel_purchase',
  'website_purchase_roas:offsite_conversion.fb_pixel_purchase',
]);

// Mapping statico dei principali geoID città Google Ads (come backend)
export const googleAdsCitiesMap: Record<string, string> = {
  '1005807': 'Paris (FR)',
  '1005811': 'Paris (FR)',
  '1005846': 'Champagne-Ardenne (FR)',
  '1005876': 'Alsace (FR)',
  '1005925': 'Corse (FR)',
  '1005928': 'Corse (FR)',
  '1005930': 'Auvergne (FR)',
  '1005948': 'Basse-Normandie (FR)',
  '1005950': 'Basse-Normandie (FR)',
  '1005951': 'Basse-Normandie (FR)',
  // ... aggiungi altri geoID e nomi città rilevanti ...
};
